module.exports = __webpack_public_path__ + "img/xr2_detail_3.33093115.jpg";